import { __extends } from "tslib";
import { each, isNumber } from '@antv/util';
import { timeFormat, toTimeStamp } from '../util/time';
import Category from './base';
/**
 * æ¶é´åç±»åº¦é
 * @class
 */
var TimeCat = /** @class */ (function (_super) {
    __extends(TimeCat, _super);
    function TimeCat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'timeCat';
        return _this;
    }
    /**
     * @override
     */
    TimeCat.prototype.translate = function (value) {
        value = toTimeStamp(value);
        var index = this.values.indexOf(value);
        if (index === -1) {
            if (isNumber(value) && value < this.values.length) {
                index = value;
            }
            else {
                index = NaN;
            }
        }
        return index;
    };
    /**
     * ç±äºæ¶é´ç±»åæ°æ®éè¦è½¬æ¢ä¸ä¸ï¼æä»¥å¤å getText
     * @override
     */
    TimeCat.prototype.getText = function (value, tickIndex) {
        var index = this.translate(value);
        if (index > -1) {
            var result = this.values[index];
            var formatter = this.formatter;
            result = formatter ? formatter(result, tickIndex) : timeFormat(result, this.mask);
            return result;
        }
        return value;
    };
    TimeCat.prototype.initCfg = function () {
        this.tickMethod = 'time-cat';
        this.mask = 'YYYY-MM-DD';
        this.tickCount = 7; // ä¸è¬æ¶é´æ°æ®ä¼æ¾ç¤º 7ï¼ 14ï¼ 30 å¤©çæ°å­
    };
    TimeCat.prototype.setDomain = function () {
        var values = this.values;
        // éå¯¹æ¶é´åç±»ç±»åï¼ä¼å°æ¶é´ç»ä¸è½¬æ¢ä¸ºæ¶é´æ³
        each(values, function (v, i) {
            values[i] = toTimeStamp(v);
        });
        values.sort(function (v1, v2) {
            return v1 - v2;
        });
        _super.prototype.setDomain.call(this);
    };
    return TimeCat;
}(Category));
export default TimeCat;
//# sourceMappingURL=time.js.map